import { useEffect } from 'react';
import './Ceros.scss';
import IframeResizer from 'iframe-resizer-react';

type CerosEmbedProps = {
  aspectratio: string;
  id: string;
  padding: string;
  src: string;
};

//Plan on removing this component

const Ceros = (props: CerosEmbedProps) => {
  useEffect(() => {
    const iframes = document.querySelectorAll('iframe[class="ceros-experience"]');
    setTimeout(() => {
      if (iframes.length > 0) {
        iframes.forEach((i) => {
          const iframe = i as HTMLIFrameElement;
          if (iframe.contentWindow) {
            console.log('Sending message to iframe');
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: 'ceros-embedded-viewport:position',
                top: 0,
                bottom: window.innerHeight,
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight,
                screenWidth: window.screen.width,
                screenHeight: window.screen.height,
              }),
              '*',
            );
          }
        });
      }
    }, 100);
  }, []);

  return props ? (
    <div
      className="ceros-iframe-wrapper"
      style={{
        padding: props.padding,
      }}
      id={props.id}
      data-aspectRatio={props.aspectratio}
    >
      <IframeResizer
        allowFullScreen
        checkOrigin={false}
        className="ceros-experience"
        log={false}
        scrolling={false}
        src={props.src}
        title="Safeco App for Agents"
      />
    </div>
  ) : (
    <></>
  );
};

export default Ceros;
